import React from 'react';
import './Speedbump.css';
import { PathUtils } from '@adobe/aem-spa-page-model-manager';

interface IChildren {
    children?: React.ReactNode;
}
interface ISpeedbumpContext {
    title: string;
    content: string;
    whitelist: string[];
}

export const SpeedbumpContext = React.createContext<ISpeedbumpContext>({
    title: '',
    content: '',
    whitelist: [],
});

export const SpeedbumpProvider = (props: IChildren) => {
    const { title, content, whitelist } = JSON.parse(PathUtils.getMetaPropertyValue('speedbumpContent') || '{}');

    return (
        <SpeedbumpContext.Provider value={{ title, content, whitelist }}>
            {props.children}
        </SpeedbumpContext.Provider>
    );
};
